import React from 'react';
import { isIOS, isAndroid } from './utils/os';
import { AndroidPage } from './AndroidPage';
import { IOSPage } from './IOSPage';
import './App.scss';
import { useState } from 'react';
import { useEffect } from 'react';

function isWx() {
  const WX_REGEX = /MicroMessenger/i;
  return WX_REGEX.test(navigator.userAgent.toLowerCase());
}

const WXOverlay = () => {
  return (
    <div className="wx-overlay">
      <div className="bubble-tips">
        <i className="icon-tips" />
        <p>由于微信限制，请戳右上角选择在浏览器或Safari打开。</p>
      </div>
    </div>
  );
};

function App() {
  const [wxMaskVisible, setWxMaskVisible] = useState(false);

  let RealPage = null;

  if (isAndroid) {
    RealPage = <AndroidPage />;
  }

  if (isIOS) {
    RealPage = <IOSPage />;
  }

  useEffect(() => {
    if (isWx()) {
      setWxMaskVisible(true);
    }
  }, []);

  return (
    <div className="app-download-page">
      {wxMaskVisible && <WXOverlay />}
      {RealPage}
      <div className="footnote">数据由深圳市欢太科技有限公司提供</div>
    </div>
  );
}

export default App;
